import { render } from "./ModalConfirm.vue?vue&type=template&id=476a776e&ts=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts"

import "./ModalConfirm.vue?vue&type=style&index=0&id=476a776e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__